export enum EClient {
  aiico = 'aiico',
  ma = 'ma',
  coronation = 'coronation',
  leadway = 'leadway',
  credit_star = 'credit_star',
  evolutics = 'evolutics',
}
